webpackJsonp([142629428675168],{

/***/ 805:
/***/ (function(module, exports) {

	module.exports = {"data":{"site":{"siteMetadata":{"facebook":{"appId":"1283025442076562"}}}},"pathContext":{}}

/***/ })

});


// WEBPACK FOOTER //
// path---index-ff1e2c8963b80eacd651.js